import type {ServiceFunctionList} from "../../../types/serviceFunctions.types";

import {deleteServiceFunction} from "@project/sdk/engineering";
import {mutationOptions} from "@tanstack/react-query";

import {serviceFunctionKeys, serviceFunctionMutationKeys} from "../../../serviceFunction-keys";

export function deleteServiceFunctionMutationOptions() {
  const listFilter = {queryKey: serviceFunctionKeys.lists()};

  return mutationOptions({
    mutationFn: (serviceFunctionId: string) => deleteServiceFunction(serviceFunctionId),
    mutationKey: serviceFunctionMutationKeys.deleteServiceFunction,
    onMutate: async (deletedId, {client}) => {
      await client.cancelQueries(listFilter);
      const previousLists = client.getQueriesData<ServiceFunctionList>(listFilter);

      for (const [key, list] of previousLists) {
        const params = key[2];
        if (
          !list ||
          typeof params !== "object" ||
          params === null ||
          !("state" in params) ||
          params.state !== "ACTIVE" ||
          !list.items.some((item) => item.serviceFunctionId === deletedId)
        )
          continue;

        client.setQueryData<ServiceFunctionList>(key, {
          ...list,
          items: list.items.filter((item) => item.serviceFunctionId !== deletedId),
          meta: {...list.meta, total: Math.max(0, list.meta.total - 1)},
        });
      }
      return {previousLists};
    },
    onError: (_error, _deletedId, context, {client}) => {
      for (const [key, snapshot] of context?.previousLists ?? [])
        client.setQueryData(key, snapshot);
    },
    onSuccess: async (_data, deletedId, _context, {client}) => {
      client.removeQueries({queryKey: serviceFunctionKeys.detail(deletedId)});
      await client.invalidateQueries(listFilter);
    },
  });
}
